export const REPLY_STATUS = [
	{ label: '', value: '' },

	{ label: 'No reply/Tiada Jawapan', value: 'no_reply' },
	{
		label: 'Had replied/ Ada Jawapan',
		value: 'had_replied'
	},

	{
		label: 'Unsatisfactory Reply / Jawapan tidak memuaskan',
		value: 'unsatisfactory_reply'
	}
];
